"use client";

import { Breadcrumb, Tabs } from "antd";
import React from "react";
import SecurityForm from "./SecurityForm";
import PaymentRangeForm from "./PaymentRangeForm";
import FooterForm from "./FooterForm";
import SocialLinksForm from "./SocialLinksForm";
import WebPages from "./WebPages";
import SupportAndHelp from "./SupportAndHelp";
import FaqForm from "./FaqForm";

const SettingsIndex = () => {
  return (
    <div className="w-full">
      <h1 className="text-lg sm:text-3xl font-semibold sm:mb-1">Settings</h1>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Dashboard" }, { title: "Settings" }]}
          className="text-xs sm:text-base"
        />
      </div>

      <Tabs
        defaultActiveKey="1"
        className="custom-tabs"
        items={[
          { key: "1", label: "Security", children: <SecurityForm /> },
          { key: "2", label: "Payment Range", children: <PaymentRangeForm /> },
          { key: "3", label: "Social Links", children: <SocialLinksForm /> },
          {
            key: "4",
            label: "Terms And Condition",
            children: <WebPages type="TERMS_CONDITION" />,
          },
          {
            key: "5",
            label: "Privacy And Policy",
            children: <WebPages type="PRIVACY_POLICY" />,
          },

          {
            key: "6",
            label: "FAQ",
            children: <FaqForm type="FAQ" />,
          },
          {
            key: "7",
            label: "Support & Help",
            children: <SupportAndHelp type="SUPPORT" />,
          },
          { key: "8", label: "Footer", children: <FooterForm /> },
        ]}
      />
    </div>
  );
};

export default SettingsIndex;
